import { Parser } from "../../../Parser";
import { observable, observe, action, Lambda, computed } from "mobx";
import { DeviceDetect } from "sb-resp-lib";
import { ScoreboardDataType } from "../../../interfaces";
// this class has ignore flag because action and observable implement interfaces
// and testing typescript interfaces is not possible with jest
// https://github.com/kulshekhar/ts-jest/issues/378
// i believe jest expects action.d.ts and observable.d.ts to be covered with tests as well as this file
// and that's why although this class is fully covered test coverage for branches without the flag is 33.3%
/* istanbul ignore next */
export class ScoreboardData {
    provider: Parser;
    scoreboardType: string;
    @observable data: ScoreboardDataType;
    backgroundImg: string;
    deviceDetect: DeviceDetect;
    disposeScoreboardData: Lambda;

    constructor(provider: Parser) {
        this.provider = provider;
        this.scoreboardType = this.provider.scoreboardType;
        this.data = this.provider.scoreboardData;
        this.backgroundImg = this.provider.backgroundImg;
        this.deviceDetect = DeviceDetect.getInstance();
        this.disposeScoreboardData = () => {};
    }

    activate() {
        this.disposeScoreboardData = observe(this.provider, "scoreboardData", change => {
            this.updateScoreboardData(change.newValue);
        });

        this.provider.activate();
    }

    deactivate() {
        this.provider.deactivate();
        this.disposeScoreboardData();
    }

    @action.bound updateScoreboardData(newValue:ScoreboardDataType) {
        this.data = newValue;
    }

    @computed get isDataLoaded() {
        return Object.keys(this.data).length > 0;
    }

}